export default "__VITE_ASSET__vcQTc9hN__"